// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3zTmz","inner":"Footer_inner__3KvDL","nextIcon":"Footer_nextIcon__1-DgQ","innerLeft":"Footer_innerLeft__UZwDg"};